<template>
  <VAutocomplete
    v-model="mutableSelectedAnalysisTypes"
    :label="$t('forms.labels.analysisTypes')"
    :items="analysisTypeList"
    :rules="{ required: true }"
    multiple
    returnObject
  />
</template>

<script>
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete';

export default {
    components: {
        VAutocomplete,
    },
    props: {
        analysisTypeList: {
            type: Array,
            default: () => [],
        },
        initialAnalysisTypes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            mutableSelectedAnalysisTypes: [...this.initialAnalysisTypes],
        };
    },
    watch: {
        mutableSelectedAnalysisTypes(items) {
            this.$emit('sendData', items);
        },
    },
};
</script>
